'use client';

// npm packages
import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';

// components
import { useDispatch, useSelector } from 'react-redux';
import { getProductNameWithModel } from '@/utils/string';
import { toggleModal } from '@/redux/reducers/wishlist-modal-reducer';
import wishlistModalsKeys from '@/constants/wishlistModals';
import Text from '../Text';
import Icon from '../Icon';

function WishlistNotificationSuccess({}) {
  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(null);
  const { wishlistNotification } = useSelector((state) => state.wishlistModal);
  const { lang: selectLang } = useSelector((state) => state.globalSettings);
  const { isOpen, data } = wishlistNotification;

  const handleClose = () => {
    dispatch(
      toggleModal({
        modalType: wishlistModalsKeys.WISHLIST_NOTIFICATION,
        isOpen: false,
        data,
      }),
    );
    setOpenModal(false);
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  useEffect(() => {
    if (openModal) {
      setTimeout(() => {
        handleClose();
      }, 5000);
    }
  }, [openModal]);

  return (
    <div
      className={classNames(
        'w-full h-full flex items-end justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0',
        {
          '!opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div
        ref={modalRef}
        className={classNames(
          'w-full lg:max-w-[720px] flex items-center justify-between gap-[6px] lg:gap-[16px] mx-8 mb-[100px] lg:mb-32 pr-12 pl-16 lg:pl-32 lg:pr-16 py-12 lg:py-16 rounded-[4px] transition-all duration-[400ms] shadow-cannot-be-added-modal',
          {
            'bg-cape-verde': openModal,
          },
        )}
      >
        <Text
          type="paragraph"
          className="text-white text-[14px] lg:text-[16px] font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px]"
        >
          {getProductNameWithModel(data, selectLang)} is added to your wishlist
        </Text>
        <div className="min-w-[24px] min-h-[24px]">
          <Icon
            type="close"
            color="#fff"
            onClick={handleClose}
            className="size-[24px] cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
}

export default WishlistNotificationSuccess;
